export const selectBrands = (state) => state.brands;

export const selectBrandPagedList = (state) => state.brands.list;
export const selectBrandPagedListLoading = (state) => state.brands.loading;
export const selectBrandPagedListLoadingCount = (state) => state.brands.loadingCount;
export const selectBrandPagedListError = (state) => state.brands.error;
export const selectBrandFilters = (state) => state.brands.filters;